import { render, staticRenderFns } from "./PlayerLevelDecrements.vue?vue&type=template&id=2b648c5e&"
import script from "./PlayerLevelDecrements.vue?vue&type=script&lang=js&"
export * from "./PlayerLevelDecrements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports